// Who counts as an employee.
//
// Fixed-term staff are employees. The handbook commits to treating them no less
// favourably than a comparable permanent member of staff, and the Flexible
// Benefits policy applies to "employees only. It does not apply to contractors,
// consultants or any self-employed individuals". Benefits used to check for
// 'permanent' (and the legacy 'full-time' / 'part-time'), which turned away
// anyone on a fixed-term contract as though they were a contractor, while leave
// already used "anything but a contractor". This is that rule, in one place,
// imported by the screens and the API alike.
//
// A blank type counts as an employee, as it always has for leave: people
// default to 'permanent', and a record nobody filled in is far more likely to
// be staff than a contractor.

export function isEmployee(employmentType) {
  return String(employmentType ?? '').trim().toLowerCase() !== 'contractor';
}

// The same rule as a SQL condition on a people column, for queries that list
// employees. `column` is a trusted identifier such as 'p.employment_type'.
export function employeeSql(column) {
  return `COALESCE(LOWER(TRIM(${column})), '') != 'contractor'`;
}
